import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NumberField } from "./number";
import { BaseFieldEditorComponent } from "../../base-field-editor.component";
import { VNumberValidators } from "../../validators";

@Component({
    selector: "field-number-editor",
    templateUrl: "./number-editor.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NumberFieldEditorComponent extends BaseFieldEditorComponent implements OnInit, OnDestroy {
    constructor(_changeDetector: ChangeDetectorRef, private _formBuilder: FormBuilder) {
        super(_changeDetector);
    }

    ngOnInit(): void {
        this.form = this._formBuilder.group(
            {
                placeholder: [this.numberField.placeholder],
                min: [this.numberField.min],
                max: [this.numberField.max],
            },
            {
                validators: VNumberValidators.greaterThan("max", "min"),
            }
        );
        super.onInit();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    get numberField() {
        return this.field as NumberField;
    }
}
